import React, { useEffect } from "react";
import { usePDF, BlobProvider } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
////// Mui
import { Link, Stack, Typography } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
////// Controls & Components
import QuotePdfDocument from "./QuotePdfDocument";

//// Register fonts / but call them in advance from Inv.js
// Font.register({
//   family: "Oswald",
//   src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
// });
// Font.register({
//   family: "Roboto",
//   fonts: [
//     {
//       src: `/Roboto-Regular.ttf`,
//     },
//     {
//       src: `/Roboto-Bold.ttf`,
//       fontWeight: "bold",
//     },
//     // {
//     //   src: `/Roboto-Normal.ttf`,
//     //   fontWeight: "normal",
//     //   fontStyle: "normal",
//     // },
//     // {
//     //   src: `/Roboto-BoldNormal.ttf`,
//     //   fontWeight: "bold",
//     //   fontStyle: "normal",
//     // },
//   ],
// });

const QuotePdf = (props) => {
  const {
    account,
    company,
    values,
    logo,
    setShowPdf,
    showPdf,
    invoicePdfLang,
    checked,
    checkedEntries,
    freeAppMssg,
  } = props;

  const { t } = useTranslation();

  const [instance] = usePDF({
    document: QuotePdfDocument(
      account,
      company,
      values,
      logo,
      invoicePdfLang,
      checked,
      checkedEntries,
      freeAppMssg
    ),
  });

  useEffect(() => {
    if (instance.blob && setShowPdf) {
      setShowPdf(false);
    }
  }, [setShowPdf, instance.blob]);

  function downloadLink(blob) {
    let element = document.createElement("a");
    element.download = `${t("quote.quote_hash")} ${values.qn || ""}`;
    element.setAttribute("href", URL.createObjectURL(blob));
    element.setAttribute("target", "_blank");
    element.style.display = "None";
    document.body.appendChild(element);
    element.click();

    document.body.removeChild(element);
  }

  if (instance.loading)
    return (
      <Typography variant='button' color='error'>
        {t("invpdf.loading_3dots")}
      </Typography>
    );

  // if (instance.error) return <div>Something went wrong, please try again.</div>;

  return (
    <>
      <BlobProvider
        document={QuotePdfDocument(
          account,
          company,
          values,
          logo,
          invoicePdfLang,
          checked,
          checkedEntries
        )}
      >
        {() => {
          return null;
        }}
      </BlobProvider>

      {showPdf && instance.blob && downloadLink(instance.blob)}
    </>
  );
};

export const QuotePdfAttachment = (props) => {
  const {
    account,
    company,
    values,
    setFile,
    logo,
    invoicePdfLang,
    setShowPdf,
    checked,
    checkedEntries,
    freeAppMssg,
  } = props;

  const { t } = useTranslation();

  const [instance] = usePDF({
    document: QuotePdfDocument(
      account,
      company,
      values,
      logo,
      invoicePdfLang,
      checked,
      checkedEntries,
      freeAppMssg
    ),
  });

  useEffect(() => {
    setFile && instance.blob && setFile(instance.blob);
  }, [instance.blob, setFile]);

  useEffect(() => {
    if (instance.blob && setShowPdf) {
      setShowPdf(false);
    }
  }, [setShowPdf, instance.blob]);

  if (instance.loading)
    return (
      <Typography variant='button' color='error'>
        {t("invpdf.loading_3dots")}{" "}
      </Typography>
    );

  // if (instance.error) return <div>Something went wrong, please try again.</div>;

  return (
    <>
      <Link
        href={instance.url}
        download={`Quote # ${values && (values.qn || "")}`}
        sx={{ textDecoration: "none", mr: 2, color: "#F40F02", width: "100%" }}
      >
        <Stack direction='row' sx={{ width: "100%", justifyContent: "center" }}>
          <PictureAsPdfIcon color='#F40F02' />
          {invoicePdfLang === "RO/RU" ? (
            <Typography variant='button' sx={{ pl: 1 }}>
              Oferta/ Ценовое предл. # {values && (values.qn || "")}
            </Typography>
          ) : (
            <Typography variant='button' sx={{ pl: 1 }}>
              Quote # {values && (values.qn || "")}
            </Typography>
          )}
        </Stack>
      </Link>
      {/* {showPdf && instance.url && downloadLink(instance.url)} */}
    </>
  );
};

export const QuotePdfBlob = (props) => {
  const {
    account,
    company,
    values,
    setFile,
    setShowPdf,
    logo,
    invoicePdfLang,
    freeAppMssg,
  } = props;

  const [blob, setBlob] = React.useState(null);

  const handleBlob = (blob) => {
    setBlob(blob);
  };

  if (blob) {
    setShowPdf(false);
    setFile(blob);
  }

  return (
    <>
      <BlobProvider
        document={QuotePdfDocument(
          account,
          company,
          values,
          logo,
          invoicePdfLang,
          freeAppMssg
        )}
      >
        {({ blob }) => {
          handleBlob(blob);
          return null;
        }}
      </BlobProvider>
    </>
  );
};

export default QuotePdf;
